import React from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { useAuthStore } from '../store/authStore'

function LoginPage() {
  const login = useAuthStore(state => state.login)
  const navigate = useNavigate()
  const location = useLocation()

  const handleLogin = (e) => {
    e.preventDefault()
    
    // Mock login
    login({ id: 1, name: 'Test User', email: 'test@example.com' }, 'mock-token')
    
    // Redirect to the page user tried to access, or dashboard
    const redirectTo = location.state?.from || '/dashboard'
    navigate(redirectTo, { replace: true })
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <Helmet><title>Anmelden | 1688 Deutschland</title></Helmet>
      
      <div className="max-w-md w-full space-y-8 bg-white p-8 rounded-xl shadow-lg">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-gray-900">Anmelden</h2>
          <p className="mt-2 text-gray-600">Willkommen zurück</p>
        </div>

        <form className="mt-8 space-y-6" onSubmit={handleLogin}>
          <div className="space-y-4">
            <input
              type="email"
              required
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
              placeholder="E-Mail Adresse"
            />
            <input
              type="password"
              required
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
              placeholder="Passwort"
            />
          </div>

          <button
            type="submit"
            className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            Anmelden
          </button>
        </form>

        <div className="text-center">
          <Link to="/register" className="text-blue-600 hover:text-blue-500">
            Noch kein Konto? Registrieren
          </Link>
        </div>
      </div>
    </div>
  )
}

export default LoginPage